module.exports = __webpack_public_path__ + "static/media/4.daf8a684.jpg";